var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgConfirmModal = function SvgConfirmModal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 46,
    viewBox: "0 0 51 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50.381,
    height: 46,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.5C12 16.5964 17.5964 11 24.5 11C31.4036 11 37 16.5964 37 23.5C37 30.4036 31.4036 36 24.5 36C17.5964 36 12 30.4036 12 23.5ZM24.5 13.2727C18.8516 13.2727 14.2727 17.8516 14.2727 23.5C14.2727 29.1484 18.8516 33.7273 24.5 33.7273C30.1484 33.7273 34.7273 29.1484 34.7273 23.5C34.7273 17.8516 30.1484 13.2727 24.5 13.2727Z",
    fill: "#FFAC71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5176 19.4824C28.9613 19.9262 28.9613 20.6457 28.5176 21.0894L22.0893 27.5177C21.6455 27.9615 20.926 27.9615 20.4823 27.5177C20.0385 27.0739 20.0385 26.3544 20.4823 25.9106L26.9105 19.4824C27.3543 19.0386 28.0738 19.0386 28.5176 19.4824Z",
    fill: "#FFAC71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4824 19.4824C20.9262 19.0386 21.6457 19.0386 22.0895 19.4824L28.5177 25.9106C28.9615 26.3544 28.9615 27.0739 28.5177 27.5177C28.074 27.9615 27.3545 27.9615 26.9107 27.5177L20.4824 21.0894C20.0387 20.6457 20.0387 19.9262 20.4824 19.4824Z",
    fill: "#FFAC71"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgConfirmModal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/confirm-modal.ec025b0ef89b63ff0df3c58319fd9456.svg";